// extracted by mini-css-extract-plugin
export default {"card":"FcHoverImage_card__gEmev","CardImg":"FcHoverImage_CardImg__1RN-w","CarBody":"FcHoverImage_CarBody__Njrle","CardBtn":"FcHoverImage_CardBtn__SFBAN"};